import request from '..'
import { useGlobalState } from '../global'
import { useSelectedWorkspaceStore } from '../workspace'
import {
  GetAllMembersResponseType,
  GetMemberParams,
  ModifyMemberValues,
  UpdateUserPayload,
  User,
} from './user.type'

export const getMe = async () => {
  const res = await request.get<DetailResponse<User>>('/v1/users/me')
  return res.data.data
}

export const updateMe = async (data: UpdateUserPayload) => {
  const res = await request.put<DetailResponse<User>>('/v1/users/me/profile', data)

  return res.data.data
}

export const changePassword = async (data: { old_password: string; new_password: string }) => {
  const res = await request.post<DetailResponse<{ message: string }>>(
    '/v1/users/change-password',
    data
  )

  return res.data.data
}

export const getUserById = async (id?: string | null) => {
  const res = await request.get<DetailResponse<User>>(`/v1/users/${id}`)

  return res.data.data
}

export const getMembers = async (params: GetMemberParams) => {
  const workspaceId = useSelectedWorkspaceStore.getState().selectedWorkspace?.id

  const res = await request.get<ListResponse<User>>('/v1/users', {
    params: {
      ...params,
      workspace_id: workspaceId,
    },
  })

  return res.data
}

export const getAllMembers = async (workspaceId?: string) => {
  const setWorkspaceMembers = useGlobalState.getState().setWorkspaceMembers
  const res = await request.get<{ data: GetAllMembersResponseType[] }>('v1/workspaces/users/all', {
    params: {
      workspace_id: workspaceId,
    },
  })

  setWorkspaceMembers?.(res.data.data)

  return res.data.data
}

export const inviteMember = async (
  workspaceId: string | undefined,
  data: Required<ModifyMemberValues>
) => {
  if (!workspaceId) return

  const res = await request.post<DetailResponse<User>>('/v1/users', {
    ...data,
    workspace_id: workspaceId,
  })

  return res.data.data
}

export const updateMember = async (
  id?: string,
  data?: { workspace_id?: string; name?: string; role?: string }
) => {
  const res = await request.put<DetailResponse<User>>(`/v1/users/${id}`, data)

  return res.data.data
}

export const removeMember = async (id: string) => {
  const workspaceId = useSelectedWorkspaceStore.getState().selectedWorkspace?.id
  if (!workspaceId) return

  const res = await request.delete<DetailResponse<{ message: string }>>(
    `/v1/workspaces/${workspaceId}/${id}`
  )

  return res.data.data
}

export const getAssignInfo = async (params: {
  workspace_id: string
  from: string
  to: string
  stage: string
}) => {
  const res = await request.get<ListResponse<User & { total_assign: number }>>('/v1/users/assign-info', {
    params,
  })

  return res.data
}

export const assignManual = async (data: {
  assignee_id: string
  conversation_id: string
  score_stage: string
}) => {
  const res = await request.post<DetailResponse<{ message: string }>>('/v1/users/assign-manual', data)

  return res.data.data
}

const UserApi = {
  getMe,
  updateMe,
  changePassword,
  getUserById,
  getMembers,
  getAllMembers,
  inviteMember,
  updateMember,
  removeMember,
  getAssignInfo,
  assignManual,
}

export default UserApi
